import {ListQuery, Endpoint, Service} from "../../const";

//Organization Actions

const endpoint = Endpoint.Role;
export const RoleService = {
    GetAllData : (data = ListQuery, token = "") => {
        let query = (data.filter ? "filter=" + data.filter : "")
        + (data.skip ? "&skip=" + data.skip : "")
        + (data.limit ? "&limit=" + data.limit : "")
        + (data.from ? "&from=" + data.from : "")
        + (data.to ? "&to=" + data.to : "")
        + (data.fields ? "&fields=" + data.fields : "")
        +( data.sortObj ? "&sortObj=" + encodeURI(JSON.stringify(data.sortObj)) : "")
        + (data.filterObj ? "&filterObj=" + encodeURI(JSON.stringify(data.filterObj)) : "");
        return Service.Request.Get(endpoint + (query !== "" ? ("?" + query) : "") ,
            token
        )
    },
    CreateData : (data, token = "") => Service.Request.Post(endpoint,data, token),
    UpdateData : (id, data, token = "") => Service.Request.Put(endpoint+ "/" + id ,data, token),
    GetDataByUsingId: (id, token = "") => Service.Request.Get(endpoint+ "/" + id, token),
    GetDataByUsingKey: (key, token = "") => Service.Request.Get(endpoint+ "/key/" + key, token),
    GetDataByUsingKeyAndOrgKey: (key, orgKey, token = "") => Service.Request.Get(endpoint+ "/key/" + key + "/org/"+ orgKey, token),
    DeleteData: (id, token = "") => Service.Request.Delete(endpoint+ "/"+ id, token),
}
